import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import App from './App';
import { store } from './src/store';
import { configureApiClient } from './src/api/client';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

// OBS Browser Source overlay: /overlay/<tableId>?token=<secret>. It needs no login, store or
// router, so it is mounted on its own and the main app (auth bootstrap, toasts) never loads.
const overlayMatch = window.location.pathname.match(/^\/overlay\/(\d+)\/?$/);
if (overlayMatch) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';
  const debug = params.get('debug') === '1';
  // &sound=1: the page plays the shot-clock beeps itself (for OBS "Control audio via OBS").
  const sound = params.get('sound') === '1';
  const StreamOverlayPage = React.lazy(() => import('./src/components/overlay/StreamOverlayPage'));
  createRoot(container).render(
    <React.Suspense fallback={null}>
      <StreamOverlayPage tableId={Number(overlayMatch[1])} token={token} debug={debug} sound={sound} />
    </React.Suspense>,
  );
} else {
  configureApiClient(store);

  const AppWithProvider = () => (
    <Provider store={store}>
      <BrowserRouter>
        <SafeAreaProvider>
          <App />
        </SafeAreaProvider>
      </BrowserRouter>
    </Provider>
  );

  createRoot(container).render(<AppWithProvider />);
}
